(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home"]) return;
  try {
    
  const SWITCH_INTERVAL = 5000;
  const images = JSON.parse(document.querySelector('script[data-images]').innerHTML);
  const switchButtons = [...document.querySelectorAll('.home-carousel > a')];
  const imageElement = document.querySelector('.home-carousel-image');
  const buyButton = document.querySelector('.home-carousel-inner > button');

  switchButtons[0].addEventListener('click', () => switchImage(-1));
  switchButtons[1].addEventListener('click', () => switchImage(1));

  buyButton.addEventListener('click', () => openProduct());

  let imageIndex = 0;

  let switchTimeout = -1;

  switchImage(0);

  function switchImage(offset) {
    clearTimeout(switchTimeout);
    imageIndex = (imageIndex + offset < 0 ? imageIndex + offset + images.length : imageIndex + offset) % images.length;
    imageElement.style.backgroundImage = `url(${images[imageIndex].image})`;
    imageElement.style.aspectRatio = images[imageIndex].aspect_ratio;
    switchTimeout = setTimeout(switchImage, SWITCH_INTERVAL, SWITCH_INTERVAL, 1);
  }

  function openProduct() {
    window.location.href = images[imageIndex].product;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-interactive"]) return;
  try {
    
  const clipUrl = document.querySelector('script[data-clip]').innerHTML;
  const button = document.querySelector('.logo-click');

  const audio = new Audio(clipUrl);

  button.addEventListener('click', () => {
    audio.play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const variants = JSON.parse(document.querySelector('script[data-variants]').innerHTML);
  const quantities = JSON.parse(document.querySelector('script[data-quantities]').innerHTML);
  const addToCartButton = document.querySelector('.product-add-to-cart');
  const soldOut = document.querySelector('.product-sold-out');
  const buyNowButton = document.querySelector('.product-buy-now');
  const quantitySelect = document.querySelector('#product-quantity');

  let productCarouselIndex = 0;

  function carouselChange(index) {
    const nImages = document.querySelector('.product-images').children.length;

    if (index < 0) {
      index = nImages - 1;
    } else if (index >= nImages) {
      index = 0;
    }

    console.log(index);

    productCarouselIndex = index;

    const sourceImage = [...document.querySelector('.product-images').children].map((el) => el.children[0])[index];
    const targetImages = [
      document.querySelector('.product-featured-image').children[0],
      document.querySelector('.popup-img-container').children[0],
    ];

    if (targetImages[0].src !== sourceImage.src) {
      for (const targetImage of targetImages) {
        targetImage.src = sourceImage.src;
        targetImage.srcset = sourceImage.srcset;
      }
    }
  }

  [...document.querySelectorAll('.product-image')].forEach((el) =>
    el.addEventListener('click', (e) => carouselChange(parseInt(e.target.parentElement.dataset.index)))
  );

  const popupNav = document.querySelector('.popup-nav');

  popupNav.children[0].addEventListener('click', () => carouselChange(productCarouselIndex - 1));
  popupNav.children[popupNav.children.length - 1].addEventListener('click', () =>
    carouselChange(productCarouselIndex + 1)
  );

  function setVariant() {
    const selected = [...document.querySelectorAll('.product-option')].map((el) => [
      parseInt(el.dataset.position) - 1,
      el.value ?? el.dataset.value,
    ]);
    selected.sort((a, b) => a[0] - b[0]);
    const targetOptions = selected.map(([_, v]) => v);
    const variant = variants.find((variant) => arrayComp(variant.options, targetOptions));
    const qty = quantities[variant.id] ?? 0;
    const maxQuantity = Math.max(1, qty);
    document.querySelector('input[name=id]').value = variant.id;

    quantitySelect.value = 1;
    [...quantitySelect.children].forEach((el, i) => {
      if (i + 1 > maxQuantity) {
        el.classList.add('hidden');
      } else {
        el.classList.remove('hidden');
      }
    });

    if (!variant.available || qty <= 0) {
      buyNowButton.classList.add('hidden');
      addToCartButton.disabled = true;
      addToCartButton.innerText = "SOLD OUT";
      soldOut.classList.remove('hidden');
    } else {
      buyNowButton.classList.remove('hidden');
      addToCartButton.disabled = false;
      addToCartButton.innerText = "Add to Cart";
      soldOut.classList.add('hidden');
    }

    if (variant.featured_image) {
      const imageIndex = [...document.querySelector('.product-images').children]
        .map((el) => el.getAttribute('data-id'))
        .findIndex((id) => Number.parseInt(id, 10) == variant.featured_image.id);

      if (imageIndex != -1) {
        carouselChange(imageIndex);
      }
    }
  }

  [...document.querySelectorAll('.product-option')].forEach((option) =>
    option.addEventListener('change', (e) => setVariant())
  );

  /**
   * @param target {HTMLButtonElement}
   */
  function movePopover(target) {
    const popover = target.popoverTargetElement;
    const { top, left, height } = getOffset(target);
    popover.style.top = `${top + height}px`;
    popover.style.left = `${left}px`;
  }

  [...document.querySelectorAll('button.position-popover')].forEach((button) =>
    button.addEventListener('click', (e) => movePopover(e.target))
  );

  } catch(e) { console.error(e); }
})();
})();
